import { h, Component } from "preact";

const WarningMessage = ({ title = "Warring", message = "" }) => {
  const style = {
      padding: '20px',
      textAlign: 'center'
  };
  return (
    <div style={style}>
      <h3>{title}</h3>
      <p>{message}</p>
    </div>
  );
};
export default WarningMessage;



// WEBPACK FOOTER //
// ./components/WarningMessage.js